import { UserCog, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  if (!user?.impersonating) return null;

  const stop = async () => {
    try {
      await api.post("/admin/exit-impersonation");
      toast.success("Back to your admin identity");
      await refresh?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not exit impersonation");
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-40 border-b border-amber-400/40 bg-amber-500/10 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-11 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-xs text-amber-100 min-w-0">
          <UserCog className="w-3.5 h-3.5 text-amber-400 flex-shrink-0" />
          <span className="font-mono uppercase tracking-widest text-[10px] text-amber-400 flex-shrink-0">
            Impersonating
          </span>
          <span className="truncate text-white font-medium">{user.email}</span>
          {user.real_admin?.email && (
            <span className="hidden md:inline text-amber-200/70 font-mono">
              · admin: {user.real_admin.email}
            </span>
          )}
        </div>
        <button
          onClick={stop}
          data-testid="impersonation-exit"
          className="text-[10px] font-mono uppercase tracking-widest border border-amber-400/40 hover:bg-amber-400/10 px-2 py-1 flex items-center gap-1 text-amber-100"
        >
          <X className="w-3 h-3" /> Exit
        </button>
      </div>
    </div>
  );
}
